<div class="error">
  <mat-dialog-content class="mat-typography">
    <h1
      *ifPermissions="[
        'Engage Transfer',
        'Engage View',
        'Create Announcements',
        'EB Rev Rec',
        'Engage Rev Rec'
      ]"
      mat-dialog-title
    >
      {{ "ErrorDialog.NoData" | translate }}
    </h1>
    <h1 *ifPermissions="['Engage Support', 'Internal Admin']" mat-dialog-title>
      {{ "ErrorDialog.NoHistory" | translate }}
    </h1>

    <h2
      *ifPermissions="[
        'Engage Transfer',
        'Engage View',
        'Create Announcements',
        'EB Rev Rec',
        'Engage Rev Rec'
      ]"
    >
      {{ "ErrorDialog.Retry" | translate }}
      <a href="mailto:mobilecredentials@allegion.com"
        >mobilecredentials&#64;allegion.com</a
      >
    </h2>
    <img
      src="../../../../../assets/Icons/transfer-error-icon-200x200.png"
      alt=""
    />
  </mat-dialog-content>

  <div class="closeButton" mat-dialog-actions>
    <button mat-button mat-dialog-close>
      {{ "ErrorDialog.Close" | translate }}
    </button>
  </div>
</div>
